import { render, staticRenderFns } from "./partGroups.vue?vue&type=template&id=40918dd9&scoped=true"
import script from "./partGroups.vue?vue&type=script&lang=js"
export * from "./partGroups.vue?vue&type=script&lang=js"
import style0 from "./partGroups.vue?vue&type=style&index=0&id=40918dd9&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40918dd9",
  null
  
)

export default component.exports